import moment from 'moment';

// TODO: check how to add functions to this date obj
const dates = moment;

export default dates;

export const getWeekNumber = (date = new Date()): number => {
    const newDate = new Date(date.getTime());
    newDate.setDate(newDate.getDate() + 4 - (newDate.getDay() || 7));
    const year = newDate.getFullYear();
    const dayOfYear = Math.floor((newDate.getTime() - new Date(year, 0, 1).getTime()) / 86400000);
    const weekNumber = Math.ceil((dayOfYear + 1) / 7);
    return weekNumber;
};
